import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

type LoadingProps = {
  caption?: string
};

const LoadingStyled = styled.div`
  all: initial;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-around;
  .bounces {
    margin: auto;
    width: 70px;
    text-align: center;
  }

  .bounces>div {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: grey;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .bounces .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .bounces .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0)
    }
    40% {
      -webkit-transform: scale(1.0)
    }
  }

  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
      background-color: ${css.secondaryColor};
    }
    40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
      background-color: ${css.primaryColor};
    }
    20% {
      background-color: '#FFF';
    }
  }
  .caption {
    text-align: center;
    font-family: ${css.fontFamily};
  }
`;

/**
 * Animated three-dot loading spinner with an optional caption.
 */
export const Loading = (props: LoadingProps = {}) => (
  <LoadingStyled className="loading">
    <div className="bounces">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
    {props.caption && <div className="caption">{props.caption}</div>}
  </LoadingStyled>
);